<div class="ui-g-12 custom-message">
	{{field.props.message}}
</div>